import { createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../api/apiSlice";

const adminAdaptor = createEntityAdapter({
    selectId: (entity) => entity.community_admin_id,
})

const initialAdmin = adminAdaptor.getInitialState()

export const extendedApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getcomplainUserApp: builder.query({
            query: () => '/b2g/eco-admin/complain/b2g-user-app',
            transformResponse: responseData => {
                if (responseData?.status === false) {
                    throw new Error(responseData?.statusCode)
                }
                return adminAdaptor.setAll(initialAdmin, responseData?.data)
            },
            // providesTags: (result, error, arg) => {
            //     console.log("result",result?.entities?.undefined);

            //     if (error || !result?.entities?.undefined?.ids) {
            //         return [{ type: 'B2gAdmin', id: 'List' }, []];
            //     } else {
            //         return result?.entities?.undefined?.map(id => ({ type: 'B2gAdmin', id }));
            //     }
            // }
        }),
        getuserappStatus: builder.query({
            query: () => '/b2g/eco-admin/complain/b2g-user-app/status',
            transformResponse: responseData => {
                if (responseData?.status === false) {
                    throw new Error(responseData?.statusCode)
                }
                return responseData?.data
            },
        }),
        edituserappApp: builder.mutation({
            query:payLoad => ({
                url: `/b2g/eco-admin/complain/b2g-user-app/${payLoad.id}`,
                method: 'PATCH',
                body: payLoad
            }),
            invalidatesTags: [
                { type: 'B2gUserApp', id: 'List' }
            ]
        }),
        // addcomplainAdmin: builder.mutation({
        //     query: body => ({
        //         url: '/b2g/eco-admin/complain/offline',
        //         method: 'POST',
        //         body: body
        //     }),
        //     invalidatesTags: [
        //         { type: 'B2gAdmin', id: 'List' }
        //     ]
        // })
    })
})
// complainUserApp
export const {
    useGetcomplainUserAppQuery,
    useGetuserappStatusQuery,
    useEdituserappAppMutation,
    // useAddcomplainAdminMutation
} = extendedApiSlice
